<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <!-- <div class="title-wrap">
        <span class="title">热点资讯</span>
      </div> -->
      <div class="content">
        <div class="tab-wrap content-wrap">
          <div class="tab-title pointer" :class="{ active: dataForm.infoType == 1 }" @click="handleTab(1)"><span>通知公告</span></div>
          <div class="tab-title pointer" :class="{ active: dataForm.infoType == 2 }" @click="handleTab(2)"><span>新闻资讯</span></div>
          <div class="tab-title pointer" :class="{ active: dataForm.infoType == 3 }" @click="handleTab(3)"><span>产业资讯</span></div>
        </div>
        <div class="cont-wrap content-wrap">
          <news-content :list="dataList" />
        </div>
      </div>
    </div>
    <div class="max-width" style="display: flex; justify-content: flex-end">
      <el-pagination
        :background="true"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :total="total"
        layout="prev, pager, next,sizes, jumper"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import NewsContent from './components/NewsContent'
import grid from '@/mixins/grid'
export default {
  name: 'HotNews',
  components: {
    Breadcrumb,
    NewsContent,
  },
  mixins: [grid],
  data() {
    return {
      module: '/zzmh/api/information/',
      dataForm: {
        infoType: 1,
      },
      dataMode: {
        infoType: 'EQ',
      },
      breadcrumb: [
        {
          path: '/',
          name: '首页',
          meta: {
            title: '首页',
          },
        },
        {
          path: '/hot-news',
          name: '热点资讯',
          meta: {
            title: '热点资讯',
          },
        },
      ],
      // isTab: 1,
      // list: [],
    }
  },
  computed: {},
  methods: {
    // listData() {
    //   this.$http({
    //     url: `zzmh/api/information/page?pageSize=${this.pageSize}&pageNum=${this.pageNo}&infoType=${this.isTab}`,
    //     method: 'get',
    //   }).then((res) => {
    //     this.pageSize = res.data.size
    //     this.total = res.data.total
    //     this.list = res.data.records
    //   })
    // },
    handleTab(type) {
      this.dataForm.infoType = type
      this.$nextTick(() => {
        this.listData()
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
